import React from 'react';
import { getConfiguration } from '../../../data/utils';
import { getLabel } from '../../../InitData';

function FlashbetTicketHeader(props) {
	
	const ticketData = props.ticketData;
	const conf = getConfiguration();
	// const frontendType = props.frontendType;
	// const aamsEnviroment = props.aamsEnviroment;
	const isCashout = props.isCashout;


	
	let ticketType = (ticketData.purchaseType === 'systembets' ? 
		    getLabel('printer.plain_ticket.header.system_bets')
		    : 
            (ticketData.purchaseType === 'singlebets' ?
                getLabel('printer.plain_ticket.header.single_bets')
                :
                getLabel('printer.plain_ticket.header.multiple_bets'))) + ' ' + getLabel('printer.plain_ticket.header.fixed_odds');
	if(isCashout){
		ticketType = ticketType + " - CASHOUT";
	}
	
	const clearBoth = {clear: "both"};
	
	return <>
    <div id="logocliente" className="d-flex- justify-content-center">
    {	
    	props.customerLogo != null && props.customerLogo.length > 0 && (
				<img src={props.customerLogo} />
		)
    }
    </div>
    <div id="logoams" className="d-flex- justify-content-center margin-top">
    	<img src={props.aamsLogo} />
    </div>
    
    <div id="tabella-superiore" className="">
	    <div>
	        <div className="td-40 left">CC: {ticketData.cc} </div>
	        <div className="td-60 left textleft">CF: {ticketData.cf }</div>
	        <div style={clearBoth}></div>
	    </div>
	    <div>
	        <div className="td-40 left">TG: {ticketData.tg }</div>
	        <div className="td-35 left">GE: {ticketData.ge}</div>
	        <div className="td-25 left textright">OE: {ticketData.oe}</div>
	        <div style={clearBoth}></div>
	    </div>
	    <div>
	        <div className="td-70 left">IB: {ticketData.idTicket}</div>
	        <div className="td-30 left textright">GR: {ticketData.gr}</div>
	        <div style={clearBoth}></div>
	    </div>
	</div>
    <h2 className="h5 bold text-align-center">{ticketType}</h2>
	</>
}

export default FlashbetTicketHeader;